import React from 'react'
import styled from 'styled-components'
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core'
import { Button, Typography } from '@material-ui/core'

type RemoveMemberDialogProps = {
  open: boolean
  onClose: () => void
}

const RemoveMemberDialogContent = styled(DialogContent)`
  width: 30vw;
`
const LabelTypography = styled(Typography)`
  color: #9e9e9e;
`
const UserNameTypography = styled(Typography)`
  margin-bottom: 28px;
`

const RemoveMemberDialog: React.FC<RemoveMemberDialogProps> = ({open, onClose}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xl">
      <DialogTitle>このフォルダのメンバーから外しますか？</DialogTitle>
      <RemoveMemberDialogContent style={{overflow: 'hidden'}}>
        <LabelTypography variant="caption">ユーザ名</LabelTypography>
        <UserNameTypography variant="h6">ぷよぷよ</UserNameTypography>
      </RemoveMemberDialogContent>
      <DialogActions>
        <Button color='primary' onClick={onClose}>
          キャンセル
        </Button>
        <Button color='primary' onClick={onClose}>
          外す
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default RemoveMemberDialog